import axiosInstance from '@/app/api/axiosInstance';
import { AccountCreate, AccountUpdate, AccountResponse } from '@/app/types';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';
import { createOrganizationFilter } from '@/app/utils/filterUtils';

export const listAccounts = async (
  params: ListQueryParams & {
    account_group_id?: number;
    account_type_id?: number;
  },
  organizationId?: number
): Promise<PaginatedResponse<AccountResponse>> => {
  try {
    const requestParams = {
      ...params,
      ...(params.filters && typeof params.filters === 'string'
        ? { filters: params.filters }
        : organizationId 
            ? { filters: createOrganizationFilter(organizationId) }
            : {})
    };

    const response = await axiosInstance.get<PaginatedResponse<AccountResponse>>(
      '/accounts/', 
      { params: requestParams }
    );
    
    return response.data;
  } catch (error) {
    console.error('Failed to list accounts:', error);
    throw error;
  }
};

export const getAccount = async (accountId: number): Promise<AccountResponse> => {
  try {
    const response = await axiosInstance.get<AccountResponse>(`/accounts/${accountId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get account with ID ${accountId}:`, error);
    throw error;
  }
};

export const createAccount = async (
  data: AccountCreate, 
  organizationId?: number
): Promise<AccountResponse> => {
  try {
    const accountData = {
      ...data,
      ...(organizationId ? { organization_id: organizationId } : {})
    };
    
    const response = await axiosInstance.post<AccountResponse>('/accounts/', accountData);
    return response.data;
  } catch (error) {
    console.error('Failed to create account:', error);
    throw error;
  }
};

export const updateAccount = async (
  accountId: number, 
  data: AccountUpdate
): Promise<AccountResponse> => {
  try {
    const response = await axiosInstance.patch<AccountResponse>(
      `/accounts/${accountId}`, 
      data
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to update account with ID ${accountId}:`, error);
    throw error;
  }
};

export const deleteAccount = async (accountId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/accounts/${accountId}`);
  } catch (error) {
    console.error(`Failed to delete account with ID ${accountId}:`, error);
    throw error;
  }
}; 